import { ReactComponent as IconUser } from 'nes.icons/icons/user.svg';
import React, { CSSProperties, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ModalManager } from '../../models/ModalManager';
import { ModalBody, ModalHeading } from './common';
import { Routes } from '../../constants';

const handleLaterBtnClick = () => {
  ModalManager.closeModal();
};

const FirstResultsModal: React.FC = () => {
  const history = useHistory();

  const handleUploadBtnClick = useCallback(() => {
    ModalManager.closeModal();
    history.push(Routes.score);
  }, [history]);

  return (
    <ModalBody>
      <ModalHeading>Your photos received first votes!</ModalHeading>
      <p>Other people voted on your photos. Check your photos to unlock the first results.</p>
      <button className={'nes-btn is-error'} style={buttonsStyle} onClick={handleUploadBtnClick}>
        Go to your photos <IconUser className={'nes-icon is-small fill-white'} style={{ margin: '0 2px 2px 0' }} />
      </button>
      <button className={'nes-btn'} style={buttonsStyle} onClick={handleLaterBtnClick}>
        See results later
      </button>
    </ModalBody>
  );
};

const buttonsStyle: CSSProperties = {
  margin: '20px',
};

export default FirstResultsModal;
